import { render, staticRenderFns } from "./ProvidersView.vue?vue&type=template&id=17a21e18"
import script from "./ProvidersView.vue?vue&type=script&lang=js"
export * from "./ProvidersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports